<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入商品名称进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <!-- <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button> -->
                </div>
                <div>
					<!-- <el-button type="success" @click="exportData" icon="el-icon-download">
						导出数据
					</el-button> -->
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加商品
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->
                <el-table-column
                        prop="kcCode"
                        align="center"
                        label="商品编码"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="kcName"
                        label="商品名称/规格"
                        align="center"
                        width="200">
                </el-table-column>
				<el-table-column
				        prop="kcPrice"
				        label="商品单价(元)"
				        align="center"
				        width="100">
				</el-table-column>
                <el-table-column
                        prop="kcCreateTime"
                        width="160"
                        align="center"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        prop="kcAddUserName"
                        width="100"
                        align="center"
                        label="创建人">
                </el-table-column>
                <el-table-column
                        prop="kcUpdateTime"
                        width="160"
						align="center"
                        label="最新修改时间">
                </el-table-column>
                <el-table-column
                        prop="kcUpdateUserName"
                        width="100"
						align="center"
                        label="最新修改人">
                </el-table-column>
                <el-table-column
						align="center"
                        prop="kcIsEnableStr"
                        width="80"
                        label="商品状态">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        width="180"
						align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
				v-loading="loading2"
				element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"
                width="80%">
            <div class="dialog-box">
                <el-form :model="kytCommodity" :rules="rules" ref="empForm">
					<el-row>
						<el-form-item label="商品编码:" prop="kcCode">
							<div class="input_box">
								<el-input size="medium" prefix-icon="el-icon-edit" v-model="kytCommodity.kcCode" maxlength="50" show-word-limit
										  placeholder="请输入商品名称/规格"></el-input>
							</div>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="商品名称/规格:" prop="kcName">
							<div class="input_box">
								<el-input size="medium" prefix-icon="el-icon-edit" v-model="kytCommodity.kcName" maxlength="50" show-word-limit
										  placeholder="请输入商品名称/规格"></el-input>
							</div>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="商品价格(元):" prop="kcPrice">
							<div class="input_box">
								<el-input size="medium" prefix-icon="el-icon-edit" v-model="kytCommodity.kcPrice" maxlength="10" show-word-limit
										  placeholder="请输入商品价格"></el-input>
							</div>
						</el-form-item>
					</el-row>
                    <el-row>
						<el-col :span="6">
						    <el-form-item label="商品状态:" prop="kcIsEnable">
						        <el-radio-group v-model="kytCommodity.kcIsEnable">
						            <el-radio :label="0">启用</el-radio>
						            <el-radio :label="1">停用</el-radio>
						        </el-radio-group>
						    </el-form-item>
						</el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doAddEmp">确 定</el-button>
			  </span>
        </el-dialog>
    </div>
</template>

<script>
	import { v4 as uuidv4 } from 'uuid'
    export default {
        name: "Tenants",
        data() {
            return {
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
                loading: false,
				loading2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
				optionIndex:[
					'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'
				],
                kytCommodity: {
					kcCode:'',
					kcName:'',
					kcPrice:'',
					kcIsEnable:''
                },
                rules: {
					kcCode: [{required: true, message: '请输入商品编码', trigger: 'blur'}],
                    kcName: [{required: true, message: '请输入商品名称/规格', trigger: 'blur'}],
					kcPrice: [{required: true, message: '请输入商品价格', trigger: 'blur'}],
					kcIsEnable: [{required: true, message: '请选择商品状态', trigger: 'blur'}]
                }
            }
        },
        mounted() {
            this.initEmps();
            this.initData();
        },
        methods: {
            emptyEmp() {
                this.kytCommodity = {
					kcCode:'',
					kcName:'',
					kcPrice:'',
					kcIsEnable:''
                }
            },
            showEditEmpView(data) {
                this.title = '编辑商品信息';
                this.emp = data;
                this.dialogVisible = true;
				this.queryFormulaInfo(data);
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/commodity/basic/del/" + data.kcId).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
			queryFormulaInfo(data){
				this.loading2 = true;
				let url = '/commodity/basic/getCommodityInfoById/'+data.kcId;
				this.getRequest(url).then(resp => {
                    this.loading2 = false;
                    if (resp.status == 200) {
						this.kytCommodity.kcCode = resp.obj.kcCode;
						this.kytCommodity.kcId = resp.obj.kcId;
						this.kytCommodity.kcName = resp.obj.kcName;
						this.kytCommodity.kcPrice = resp.obj.kcPrice;
						this.kytCommodity.kcIsEnable = parseInt(resp.obj.kcIsEnable)
                    }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
                });
			},
            doAddEmp() {
                if (this.kytCommodity.kcId) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/commodity/basic/update", this.kytCommodity).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/commodity/basic/add", this.kytCommodity).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
				
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加商品';
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                let url = '/commodity/basic/getCommoditysList?page=' + this.page + '&size=' + this.size;
                url += "&kcName=" + this.keyword;
				
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	.el-form-item {
		display: flex;
		.input_box {
			width: 28.5rem;
			.el-input {
				width: 100% !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
	.options_warp {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		.option_item {
			margin-bottom: 0.625rem;
		}
	}
	::v-deep .dialog-box {
		.el-form-item__label {
			width: 8.125rem;
		}
	}

</style>
